import type { AutomationInputsType, NodeContextType } from '@unifyapps/defs/types/dataSource';
import { CALLABLE_DATA_SOURCE_TYPES, type UAResources } from '@unifyapps/defs/types/resources';

// resolves the raw ids the Pulse "view run" link needs for a callable-automation data source.
// Building the actual run URL is a builder-only concern — see getCallableAutomationRunUrl below,
// which is called only on the pulse-on path, never in the shared data-fetch return.
export function getCallableAutomationId(
  context: NodeContextType | undefined,
  inputs: AutomationInputsType | undefined,
): string | undefined {
  if (
    !context?.resourceName ||
    !CALLABLE_DATA_SOURCE_TYPES.has(context.resourceName as UAResources)
  ) {
    return undefined;
  }
  return inputs?.automationId;
}

// pulls the raw execution id off a callable-automation response — no route/URL knowledge, safe to
// call in the shared (runner-reachable) data-fetch path.
export function getExecutionInstanceId(rawResponse: unknown): string | undefined {
  if (!rawResponse || typeof rawResponse !== 'object') return undefined;
  const executionInstanceId = (rawResponse as { executionInstanceId?: unknown })
    .executionInstanceId;
  return typeof executionInstanceId === 'string' ? executionInstanceId : undefined;
}

// builds the platform run-route from raw ids. Builder-only: called from the pulse lifecycle's
// pulse-on branch so the runner never constructs this URL.
export function getCallableAutomationRunUrl(
  automationId: string | undefined,
  executionInstanceId: string | undefined,
): string | undefined {
  if (!automationId || !executionInstanceId) return undefined;
  return `/automations/${automationId}/runs/${executionInstanceId}`;
}
